<template>
	<article class="department-manage">
		<div class="department-manage__section-wrap">
			<managing-section
				:is-table="true"
				v-for="departmentItem in department_list"
				:key="departmentItem.idCommon"
			>
				<template slot="topBar">
					<div
						class="section__info__left department-manage__section__title"
					>
						{{ departmentItem.commonText }}
					</div>
					<div class="section__info__right">
						<button
							class="btn section__info__items"
							type="button"
							@click="
								modifyDepartment(
									departmentItem.idCommon,
									departmentItem.commonText
								)
							"
						>
							수정
						</button>
						<button
							class="btn-delete section__info__items"
							type="button"
							@click="deleteDepartment(departmentItem.idCommon)"
						>
							삭제
						</button>
					</div>
				</template>
				<table class="table-main department-manage__table">
					<thead>
						<tr>
							<th class="department-manage__account-img-col">
								사진
							</th>
							<th>이름</th>
							<th>직급</th>
							<th class="department-manage__remove-col">제외</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="item in departmentItem.account_list"
							:key="item.idRegister"
						>
							<td class="department-manage__account-img-col">
								<img
									class="department-manage__account-img"
									:src="`${adminImgUrl}${item.fileDir}/${item.fileSaveName}`"
									v-if="item.fileSaveName"
								/>
							</td>
							<td>{{ item.nickName }}</td>
							<td>{{ getPositionName(item.position) }}</td>
							<td class="department-manage__remove-col">
								<button
									class="btn"
									type="button"
									@click="excludeAccount(item.idRegister)"
								>
									제외
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</managing-section>
		</div>
		<div class="department-manage__section-wrap">
			<managing-section :is-table="true">
				<template slot="topBar">
					<div
						class="section__info__left department-manage__section__title"
					>
						직원 리스트
					</div>
				</template>
				<table class="table-main department-manage__table">
					<thead>
						<tr>
							<th class="department-manage__account-img-col">
								사진
							</th>
							<th>이름</th>
							<th>직급</th>
							<th class="department-manage__remove-col">지정</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="item in independence_list"
							:key="item.idRegister"
						>
							<td class="department-manage__account-img-col">
								<img
									class="department-manage__account-img"
									:src="`${adminImgUrl}${item.fileDir}/${item.fileSaveName}`"
									v-if="item.fileSaveName"
								/>
							</td>
							<td>{{ item.nickName }}</td>
							<td>{{ getPositionName(item.position) }}</td>
							<td class="department-manage__remove-col">
								<button
									class="btn"
									type="button"
									@click="assignDepartment(item.idRegister)"
								>
									지정
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</managing-section>
		</div>
	</article>
</template>

<script>
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';

	export default {
		name: 'DepartmentManage',
		components: { ManagingSection, ManagingBox },
		data() {
			return {
				department_list: null,
				independence_list: null,
			};
		},
		computed: {
			...mapState({
				adminImgUrl: state => state.env.adminImgUrl,
			}),
			...mapGetters(['getItemById']),
		},
		created() {
			this.getTableData();
		},
		methods: {
			async getTableData() {
				try {
					const { data } =
						await this.$axiosSupport.get('/admin/department');
					this.department_list = data.department_list;
					this.independence_list = data.independence_list;
				} catch (err) {
					console.error(err);
					alert(
						'직원목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			getPositionName(position) {
				const obj = this.getItemById('position', position);
				return obj ? obj.name : '';
			},
			modifyDepartment(idCommon, commonText) {
				this.$store.commit('modal/toggleModal', {
					id: 'DepartmentAssign',
					contsTitle: '수정할 부서명을 입력',
					params: { idCommon, commonText, type: 'modify' },
				});
			},
			async deleteDepartment(idCommon) {
				try {
					if (!confirm('정말 부서를 삭제 할까요?')) return;
					await this.$axiosSupport.delete(
						`/admin/department/${idCommon}`
					);
					location.reload();
				} catch (err) {
					console.error(err);
					alert(
						'부서를 삭제하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async excludeAccount(idRegister) {
				try {
					if (!confirm('관리자를 부서에서 제외 할까요?')) return;
					const params = {
						adminAccount: { department: null },
					};
					await this.$axiosSupport.put(
						`/admin/adminAccount/${idRegister}`,
						params
					);
					location.reload();
				} catch (err) {
					console.error(err);
					alert(
						'관리자를 제외하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			assignDepartment(idRegister) {
				this.$store.commit('modal/toggleModal', {
					id: 'DepartmentAssign',
					contsTitle: '지정할 부서명을 선택',
					params: { type: 'assign', idRegister },
				});
			},
		},
	};
</script>

<style lang="scss">
	.department-manage__section-wrap {
		float: left;
		width: 50%;
		padding-left: 8px;

		&:first-child {
			padding-left: 0;
			padding-right: 8px;
		}

		@media (max-width: 768px) {
			float: none;
			width: 100%;
			padding-left: 0;

			&:first-child {
				padding-right: 0;
			}
		}
	}

	.department-manage__section__title {
		font-weight: bold;
		font-size: 1.375rem !important;
	}

	.department-manage__table {
		table-layout: fixed;
	}

	.department-manage__account-img-col {
		width: 90px;
	}

	.department-manage__account-img {
		display: block;
		width: 74px;
		height: auto;
	}

	.department-manage__remove-col {
		width: 76px;
	}
</style>
